export default "__VITE_ASSET__95680895__"